export default __webpack_public_path__ + "7dd5bdb6291102043380a6675c9817f0.png";